import { HttpServiceError } from 'common/api';
import { authStore } from 'stores';
import { config } from 'config';

const httpTest = new RegExp("^(http|https)://", "i");

class HttpService {
    async get(url, options) {
        const rsp = await this.request(url, 'GET', this.createOptions(options));
        return await rsp.json();
    }

    async post(url, body, options) {
        const rsp = await this.request(url, 'POST', this.createOptions(options, body));
        return await rsp.json();
    }

    async put(url, body, options) {
        const rsp = await this.request(url, 'PUT', this.createOptions(options, body));
        return await rsp.json();
    }

    async delete(url, options) {
        const rsp = await this.request(url, 'DELETE', this.createOptions(options));
        return await rsp.json();
    }

    async download(url, options) {
        const rsp = await this.request(url, 'GET', this.createOptions(options));
        return await rsp.blob();
    }

    async downloadPDF(url, body, options) {
        const rsp = await this.request(url, 'POST', this.createOptions(options, body));
        return await rsp.blob();
    }


    createURL(url) {
        if (!httpTest.test(url)) {
            const rootUrl = config.apiUrl;
            if (url.indexOf(rootUrl) < 0) {
                return rootUrl + '/' + url.ltrim('/');
            }
        }
        return url;
    }

    async request(url, method, options) {
        options = options || {};
        options.method = method;
        options.headers = options.headers || new Headers();
        if (options) {
            if (options.body) {
                setDefaultHeaders(options.headers);
            }
        }

        const token = authStore.getAccessToken();
        if (token) {
            options.headers.set('Authorization', 'Bearer ' + token);
        }

        const request = new Request(this.createURL(url), options);

        try {
            const response = await fetch(request);
            this.checkResponseStatus(response);
            return response;
        } catch (ex) {
            throw new HttpServiceError({
                ex,
                request,
                response: ex.response
            });
        }
    }

    createOptions(options, body) {
        if (options) {
            options = {
                ...options
            }
        } else {
            options = {};
        }

        if (body) {
            options.body = JSON.stringify(body);
            options.headers = options.headers || new Headers();
            setDefaultHeaders(options.headers);
        }
        return options;
    }

    checkResponseStatus(response) {
        if (response.status === 401) {
            authStore.removeSession();
        }

        if (!response.ok) {
            const ex = { 
                response: response,
            };
            throw ex;
        }

        return response;
    }
}

function setDefaultHeaders(headers) {    
    if (!headers.get('Content-Type')) {
        headers.set('Content-Type', 'application/json');
    }
}

const httpService = new HttpService();
export { httpService }


// WEBPACK FOOTER //
// ./src/common/api/httpService.js